module.exports = __webpack_public_path__ + "img/page-not-found.c7192dc0.png";